import {
  CHANGE_IMPORTER_SELECTED_FILE,
  CHANGE_IMPORTER_SELECTED_COMPANY,
  CHANGE_IMPORTER_CASES,
  CHANGE_IMPORTER_STATUS,
  CHANGE_IMPORTER_SUMMARY
} from './actions'

export default function(state = {
  selectedFile: '',
  selectedCompany: '',
  headers: [
    { label: 'Status', value: 'status' },
    { label: 'Número do Processo', value: 'lawsuitNumber' },
    { label: 'UF do Processo', value: 'lawsuitUf' },
    { label: 'Nome do Cliente', value: 'clientName' },
    { label: 'Número da OAB', value: 'oabNumber' },
    { label: 'UF da OAB', value: 'oabUf' },
    { label: 'Alçada', value: 'maxValue' },
    { label: 'Provisão', value: 'provision', optional: true },
    { label: 'Outras Obrigações', value: 'obligation', optional: true },
    { label: 'Código do Sitema', value: 'ps', optional: true },
    { label: 'Mensagem', value: 'message', optional: true },
    { label: 'Classificadores', value: 'classifiers', optional: true },
    { label: 'Prazo', value: 'deadline', optional: true }
  ],
  cases: [],
  status: '',
  summary: {
    total: 0,
    imported: 0,
    errors: 0,
    averageTime: 0,
    timeLeft: 0
  }
}, action) {
  switch(action.type) {
    case CHANGE_IMPORTER_SELECTED_FILE:
      return { ...state, selectedFile: action.payload }
    case CHANGE_IMPORTER_SELECTED_COMPANY:
      return { ...state, selectedCompany: action.payload }
    case CHANGE_IMPORTER_CASES:
      return { ...state, cases: action.payload }
    case CHANGE_IMPORTER_STATUS:
      return { ...state, status: action.payload }
    case CHANGE_IMPORTER_SUMMARY:
      return { ...state, summary: action.payload }
    default:
      return state
  }
}
